module.exports = {
  CssSelectorParser: require('./lib/css-selector-parser.js').CssSelectorParser
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/css-selector-parser/index.js
 ** module id = 694
 ** module chunks = 0
 **/